module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// /app/~/stream-browserify/~/readable-stream/writable-browser.js
// module id = 94
// module chunks = 0